import React, { useCallback } from 'react'
import styled from 'styled-components'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import TasteOfGoldLearnMoreContent from './TasteOfGoldLearnMoreContent'

const ScrollContainer = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
`

function TasteOfGoldLearnMoreModal() {
  const modalContext = useModalElementContext()
  const handleNavigateAway = useCallback(() => modalContext.resolve(), [modalContext])

  return (
    <ModalBase dismissible>
      <ModalHeader title="" isOverlay paletteType="inverse" />
      <ScrollContainer>
        <TasteOfGoldLearnMoreContent onNavigateAway={handleNavigateAway} />
      </ScrollContainer>
    </ModalBase>
  )
}

export default TasteOfGoldLearnMoreModal
